// entry-id.mjs — 条目编号的**唯一**正则（第一百八十批抽出）。
//
// 「条目」＝列表项开头的粗体编号：`**FR-P1 …**` / `**DS-A8a …**` / `**OG-27 …**`。
// 此前这条正则只活在 scripts/lint/data-content-parity.mjs 里（zh/en 结构齐平判据
// 拿它数条目）。本批起发布态渲染要给同一批条目发 `<li id="FR-P1">`，断锚判据又要
// 拿同一集合去核 `functional-requirements.md#FR-P4` 这种链接——三处若各写一遍，
// 迟早有一处放宽或收紧而另两处不知道：齐平判据数到了、页面却没发 id，链接就死。
// 一处定义、三处 import，是"写下了 ≠ 生效了"这类缺陷的最便宜的预防。
//
// 形状：两到三个大写字母 + `-` + 字母数字串，`\b` 收尾；小写开头的（`web-novel…`）
// 天然不匹配。工单号（SB-/BUG-…）也匹配——齐平判据自己按命名空间排除，渲染侧
// 不排：给一条工单引用发个 id 无害，而按命名空间排除会让"哪些条目有锚"多一条规则。
export const RE_ENTRY_LABEL = /^\*\*([A-Z]{2,3}-[0-9A-Za-z]+)\b/;

// 列表项**去掉 marker 之后**的行内文本 → 条目编号；不是条目返回 null。
// 只看开头：条目编号必须是项的第一个字，句中提到的 `**FR-P4**` 不算。
export function entryIdOf(text) {
  const m = RE_ENTRY_LABEL.exec(String(text ?? ''));
  return m ? m[1] : null;
}
